import * as React from 'react';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { GetString } from '../StringResourceManager';
import { deviceStatusesNameMap } from '../../utils/textMappings';
import StringResources from '../../utils/stringResources';
import { filterClearIcon } from '@progress/kendo-svg-icons';
import { HeaderTdElement } from '@progress/kendo-react-data-tools';
import DynamicDropDownList from '../DynamicDropDownList';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    spaceBetween: {
      marginInline: 2,
    },
  })
);

interface StatusDropDownFilterCellProps extends GridCustomFilterCellProps {
  defaultItem: string;
  data: string[];
  onChangeValueCheckFunc: (event: any) => any;
}

const getColor = (value: number): string => {
  switch (value) {
    case 1:
      return 'green';
    case 2:
      return 'orange';
    case 3:
      return 'red';
    default:
      return 'gray';
  }
};

export const StatusDropDownFilterCell = (
  props: StatusDropDownFilterCellProps
) => {
  const selectedValue = GetString(deviceStatusesNameMap(props.value));

  let hasValue: any = (value: string) =>
    Boolean(value !== undefined && value !== '' && value !== props.defaultItem);

  const onChange = (event: DropDownListChangeEvent) => {
    hasValue = hasValue(event.target.value);

    props.onChange({
      value: hasValue ? props.onChangeValueCheckFunc(event.target.value) : '',
      operator: hasValue ? 'eq' : '',
      syntheticEvent: event.syntheticEvent,
    });
  };

  const onClearButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    if (event) event.preventDefault();
    props.onChange({
      value: '',
      operator: '',
      syntheticEvent: event,
    });
  };

  const classes = useStyles();

  const valueRender = (
    element: React.ReactElement<HTMLSpanElement>,
    value: any
  ) => {
    if (!value) {
      return element;
    }

    const children = [
      <span
        key={1}
        style={{
          display: 'inline-block',
          background:
            value === StringResources.English.ALL ||
            value === StringResources.French.ALL
              ? undefined
              : getColor(props.value),
          color: '#fff',
          borderRadius: '50%',
          width: '18px',
          height: '18px',
          textAlign: 'center',
          overflow: 'hidden',
        }}
      />,
      <span key={2}>&nbsp; {value}</span>,
    ];

    return React.cloneElement(element, { ...element.props }, children);
  };

  return (
    <HeaderTdElement
      columnId={props.thProps?.columnId || ''}
      {...props.thProps}
    >
      <div className="k-filtercell">
        <DynamicDropDownList
          data={props.data}
          onChange={onChange}
          valueRender={valueRender}
          value={hasValue(props.value) ? selectedValue : props.defaultItem}
          defaultItem={props.defaultItem}
        />
        <div className={classes.spaceBetween} />
        <Button
          title={GetString('CLEAR')}
          disabled={!hasValue(props.value)}
          onClick={onClearButtonClick}
          svgIcon={filterClearIcon}
        ></Button>
      </div>
    </HeaderTdElement>
  );
};
